import React, { Component } from 'react';
import { NavLink, Navigate } from 'react-router-dom';
import axios from 'axios';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody';
import SettingsIcon from '@mui/icons-material/Settings';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import { blueGrey } from '@mui/material/colors';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Tooltip from '@mui/material/Tooltip';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import DeleteIcon from '@mui/icons-material/Delete';
import Sendemail from './Sendemail';
import Columnsettings from './Columnsettings';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import logoImage from './images/logo.jpg';
import Dialog from '@mui/material/Dialog';      
import DialogActions from '@mui/material/DialogActions'; 
import DialogContent from '@mui/material/DialogContent'; 
import DialogTitle from '@mui/material/DialogTitle'; 




const styles = {
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
};

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (!Array.isArray(array)) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

export default class Salesdaybookreport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sestatus: '',
      isselectdisplay: false,
      open: false,
      currentDate: new Date(),
      month1: '',
      lastDayOfMonth: '',
      lastDay: '',
      todate1: '',
      todate: '',
      fromdate: '',
      fromdate1: '',
      salesbookData: [], 
      totaldata:0,
      type: 0,
      redirect: false,
      pagename: '',
      id: '',
      page: 0,
      prevpage: 0,
      rowsPerPage: 50,
      rowsPaging: [],
      quotenumber: '',
      contactname: '',
      search: '',
      order: 'desc',
      orderBy: 'sin_id',
      iconslist: false,
      allchecked: false,
      showSummary: true, 
      fromDateEnabled: false,
      toDateEnabled: false,
	  openExportDialog: false,
	  salesdetailsbookData:[],
    };
    this.todatehandler = this.todatehandler.bind(this);
    this.fromdatehandler = this.fromdatehandler.bind(this);
    this.onchangedateHandler = this.onchangedateHandler.bind(this);
    this.myChangeHandler = this.myChangeHandler.bind(this);
    this.Handleclickviewmore = this.Handleclickviewmore.bind(this);
    this.CloseMoreoption = this.CloseMoreoption.bind(this);
    this.handleClickSearch = this.handleClickSearch.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.toggleSummaryDetails = this.toggleSummaryDetails.bind(this);

    this.tableRef = React.createRef(); 
  }

  componentWillMount() {
    document.title = 'Isifol - Sales Day Report';
    	  if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {	
this.apicall(this.state.page, this.state.rowsPerPage);	  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
    this.props.parentdasCallback('Sales Day Report~');
    
  }
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=31')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
this.apicall(this.state.page, this.state.rowsPerPage);
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
  apicall(page, rowsPerPage) {
    axios.get(localStorage.getItem('ISIurl') + 'ajaxreports.php?action=salesdaygetall&fromdate=' +this.state.fromdate1+'&todate='+this.state.todate1 +'&sin_quotenumber=' + this.state.quotenumber + '&cu_businessname=' + this.state.contactname  + '&StartIndex=' + page + '&sin_cmp_id='+localStorage.getItem("ISIcmpid")+'&PageSize=' + rowsPerPage+'&type='+this.state.type)
      .then((resp) => {
        if (resp.data && resp.data.length > 0) {
          let copy = [50, 100, 150, 200, 250];
          this.setState({
            salesbookData: resp.data, 
            totaldata: parseInt(resp.data[0].count),
            rowsPaging: copy,
          });
        } else {
          this.setState({ salesbookData: [], totaldata: 0 });
        }
      })
   
  }


  apicalldetails(page, rowsPerPage) {
    axios.get(localStorage.getItem('ISIurl') + 'ajaxreports.php?action=salesdaydetailesgetall&fromdate=' +this.state.fromdate1+'&todate='+this.state.todate1 +'&sin_quotenumber=' + this.state.quotenumber + '&cu_businessname=' + this.state.contactname  + '&sin_cmp_id='+localStorage.getItem("ISIcmpid")+'&StartIndex=' + page + '&PageSize=' + rowsPerPage+'&type='+this.state.type)
      .then((resp) => {
		  
		
		  
        if (resp.data && resp.data.length > 0) {
          let copy = [50, 100, 150, 200, 250];
          this.setState({
            salesdetailsbookData: resp.data, 
            totaldata:parseInt(resp.data[0].count),
            rowsPaging: copy,
          });
        } else {
          this.setState({ salesdetailsbookData: [], totaldata: 0 });
        }
      })
   
  }


    handleDownload = () => {
        const { salesbookData, showSummary } = this.state;
        const doc = new jsPDF();
		
		const imgWidth = 40;  
    const imgHeight = 12; 
    const imgX = (doc.internal.pageSize.width - imgWidth) / 2; 
    const imgY = 10;      
doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);

 
    const title = 'Sales Day Book Report';
    doc.setFontSize(16);

  
    const titleY = imgY + imgHeight + 8;

    doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });
	const tableStartY = titleY + 10; 


        const headers = [
            [ 'Type', 'Date', 'Name', 'Invoice Number', 'Reference', 'Details', 'Net', 'Tax', 'Total']
        ];

        const rows = [];

        salesbookData.forEach(mainItem => {
            let strtype = "";
            if (mainItem.type === "0") { 
                strtype = "All";
            } else if (mainItem.type === "1") {
                strtype = "Sales Invoice";
            } else if (mainItem.type === "2") {
                strtype = "Sales Credit Notes";
            } else if (mainItem.type === "3") { 
                strtype = "Sales Credit Notes";
            } else if (mainItem.type === "4") {
                strtype = "Sales QE Credit";
            } else if (mainItem.type === "5") {
                strtype = "Sales QE Invoice";
            } else if (mainItem.type === "6") { 
                strtype = "Customer OB Credit";
            } else if (mainItem.type === "7") { 
                strtype = "Customer OB Invoice";
            }

           
            rows.push([
             
                strtype,
                mainItem.invoicedate || '', 
                mainItem.cu_businessname || '',
                mainItem.sin_invoiceno || '',
                mainItem.sin_reference || '', 
                '', 
                mainItem.iop_total || 0, 
                mainItem.taxvalue || 0, 
                mainItem.iop_total || 0, 
            ]);

           
            if (!showSummary && mainItem.subcat && mainItem.subcat.length > 0) {
                mainItem.subcat.forEach(subItem => {
                    rows.push([
                       
                        '', 
                        '', 
                        '',
                        'No tax', 
                        subItem.sin_reference || '',
                        subItem.details || '', 
                        subItem.iop_total || 0, 
                        subItem.taxvalue || 0,
                        subItem.iop_total || 0,
                    ]);
                });
            }
        });

        doc.autoTable({
            head: headers,
            body: rows,
            startY: 20,
            theme: 'grid',
            didDrawPage: function (data) {
                var str = "Page " + doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
            }
        });

        doc.save('Salesdaybookreport.pdf');
    };


    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };


  myChangeHandler(event) {
    let nam = event.target.name;
    let val = event.target.value;
    this.setState({ [nam]: val });
  }

  Handleclickviewmore(e) {
    this.setState({ isselectdisplay: true });
  }

  handleClickSearch() {
   
	  this.apicall(this.state.page, this.state.rowsPerPage)
   
  }

  fromdatehandler(date) {
    var dateObj = new Date(date);
    this.setState({
      fromdate: dayjs(dateObj),
      fromdate1:
        dateObj.getFullYear() +
        '-' +
        (dateObj.getMonth() + 1) +
        '-' +
        dateObj.getDate(),
      fromDateEnabled: true,
    });
  }

  onchangedateHandler(event) {
    let selectedOption = event.target.value;
    const periodMap = {
      'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
      'This Quarter': [dayjs().startOf('month'), dayjs().endOf('month').add(3, 'month')],
      'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
      'Last Month': [
        dayjs().subtract(1, 'month').startOf('month'),
        dayjs().subtract(1, 'month').endOf('month'),
      ],
      'Last Quarter': [dayjs().endOf('month'), dayjs().startOf('month').subtract(3, 'month')],
      'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
      'This Financial Year': [dayjs().startOf('year').month(3), dayjs().endOf('year').month(2).add(1, 'year')],
      'Last Financial Year': [
        dayjs().subtract(1, 'year').startOf('year').month(3),
        dayjs().subtract(1, 'year').endOf('year').month(2).add(1, 'year'),
      ],
      Custom: [dayjs(), dayjs().endOf('month')],
    };

    if (selectedOption === 'Custom') {
      this.setState({
        fromdate: periodMap['Custom'][0],
        todate: periodMap['Custom'][1],
        fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
        todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
        fromDateEnabled: true,
        toDateEnabled: true,
      });
    } else {
      this.setState({
        fromdate: periodMap[selectedOption][0],
        todate: periodMap[selectedOption][1],
        fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
        todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
        fromDateEnabled: false,
        toDateEnabled: false,
      });
    }
  }

  handleChangePage(event, newPage) {
    this.setState({ page: newPage }, () => {
      this.apicall(this.state.page, this.state.rowsPerPage);
    });
  }

  handleChangeRowsPerPage(event) {
    let pageval = event.target.value;
    this.setState({ rowsPerPage: parseInt(pageval), page: 0 }, () => {
      this.apicall(this.state.page, this.state.rowsPerPage);
    });
  }

  todatehandler(date) {
    var dateObj = new Date(date);
    this.setState({
      todate: dayjs(dateObj),
      todate1:
        dateObj.getFullYear() +
        '-' +
        (dateObj.getMonth() + 1) +
        '-' +
        dateObj.getDate(),
      toDateEnabled: true,
    });
  }

  CloseMoreoption() {
    this.setState({ isselectdisplay: false });
  }

  toggleSummaryDetails() {
    this.setState((prevState) => ({
      showSummary: !prevState.showSummary,
    }));
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.pagename} />;
    }
let GrandNetTotal=0;
let GrandTaxTotal=0;

    const { salesbookData, showSummary, order, orderBy } = this.state;

    const getTypeString = (type) => {
      switch (type) {
        case '0':
          return 'All';
        case '1':
          return 'Sales Invoice';
        case '2':
          return 'Sales Credit Notes';
       
        default:
          return '';
      }
    };

    return (
      <React.Fragment>
        <div className="searchbox">
          <ul>
            <li>
              <p>Search</p>
              <p>
                <TextField
                  variant="outlined"
                  fullWidth
                  className="txtbox"
                  value={this.state.quotenumber}
                  id="quotenumber"
                  inputProps={{ tabIndex: '1', maxLength: 150 }}
                  name="quotenumber"
                  onChange={this.myChangeHandler}
                  InputProps={{
                    endAdornment: <SearchOutlinedIcon style={{ marginLeft: 8 }} />,
                  }}
                />
              </p>
            </li>
            <li>
              <p>Period</p>{' '}
              <p>
                <Select
                  native
                  variant="outlined"
                  className="txtbox"
                  margin="normal"
                  fullWidth
                  onChange={this.onchangedateHandler}
                  inputProps={{ tabIndex: '4' }}
                >
                  <option>This Month</option>
                  <option>This Quarter</option>
                  <option>This Year</option>
                  <option>Last Month</option>
                  <option>Last Quarter</option>
                  <option>Last Year</option>
                  <option>This Financial Year</option>
                  <option>Last Financial Year</option>
                  <option>Custom</option>
                </Select>
              </p>
            </li>
            <li>
              <p>From Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    disabled={!this.state.fromDateEnabled}
                    value={this.state.fromdate ? dayjs(this.state.fromdate) : null} 
                    className="txtbox"
                    onChange={this.fromdatehandler}
                    format="MM/DD/YYYY"
                  />
                </DemoContainer>
              </LocalizationProvider>
            </li>
            <li>
              <p>To Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    disabled={!this.state.toDateEnabled}
                    value={this.state.todate ? dayjs(this.state.todate) : null} 
                    className="txtbox"
                    onChange={this.todatehandler}
                    format="MM/DD/YYYY"
                  />
                </DemoContainer>
              </LocalizationProvider>
            </li>
            <li>
              <p>&nbsp;</p>
              <p>
                <Button type="submit" variant="outlined" className="morebtn" onClick={this.Handleclickviewmore}>
                  More
                </Button>
                <span className="closeincon">
                  {this.state.isselectdisplay === true && <CloseRoundedIcon onClick={this.CloseMoreoption} />}
                </span>
              </p>
            </li>
            <li>
              <p>&nbsp;</p>
              <p className="searchbutton">
                <Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
                  Calculate
                </Button>
                &nbsp;
				
				  <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog} 
                                >
                                    EXPORT
                                </Button>
				
				
				
				
				
				
                
              </p>
			  </li>
			  <li>
			
             
              <Button className="frmSecondarybtn" style={{ color: '#fff' }} variant="outlined" onClick={this.toggleSummaryDetails}>
                {this.state.showSummary ? 'Detailed' : 'Summary'}
              </Button>
            </li>
            {this.state.isselectdisplay === true && (
              <li>
                <p>Type</p>{' '}
                <p>
                  <Select
                    native
                    variant="outlined"
                    className="txtbox"
                    margin="normal"
                    fullWidth
                    onChange={this.myChangeHandler}
                    id="type"
                    value={this.state.type}
                    name="type"
                    inputProps={{ tabIndex: '4' }}
                  >
                    <option value={0}>All</option>
                    <option value={1}>Sales Invoice</option>
                    <option value={2}>Sales Credit Note</option>
            
                  </Select>
                </p>
              </li>
            )}
          </ul>
        </div>
        <div className="clear"></div>
        <div className="estimatebox">
          <Paper style={styles.root}>
            <TableContainer style={styles.container}>
              <Table stickyHeader aria-label="sticky table" id="salesbook" ref={this.tableRef}>
                <TableHead>
                  <TableRow>
                    <TableCell>Type </TableCell>
                    <TableCell> Date</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell> Invoice Number</TableCell>
                    <TableCell>Reference </TableCell>
                    <TableCell>Details </TableCell>
                    <TableCell>Net </TableCell>
                    <TableCell>Tax </TableCell>
                    <TableCell>Total </TableCell>
                  </TableRow>
                </TableHead>
    <TableBody>
  {stableSort(salesbookData, getSorting(order, orderBy)).map((mainItem, mainIndex) => {
   
	   
            GrandNetTotal += (Number(mainItem.iop_total) || 0);
            GrandTaxTotal += Number(mainItem.taxvalue);
          
	
    const typeStr = String(mainItem.type);
    const id = mainItem.sin_id || mainItem.scn_id; 
    let strlink = '';

    if (typeStr === '1') {
      strlink = `#/Salesinvoiceviewmore?sinoid=${id}`;
    } else if (typeStr === '2') {
      strlink = `#/Salecreditnoteviewmore?scnoid=${id}`;
    }

    return (
      <React.Fragment key={mainIndex}>
        <TableRow
          style={{ cursor: strlink ? 'pointer' : 'default' }}
          onClick={() => { if (strlink) window.location.href = strlink; }}
        >
          <TableCell>{getTypeString(mainItem.type)}</TableCell>
          <TableCell>{mainItem.invoicedate}</TableCell>
          <TableCell>{mainItem.cu_businessname}</TableCell>
          <TableCell>{mainItem.sin_invoiceno}</TableCell>
          <TableCell>{mainItem.sin_reference}</TableCell>
          <TableCell></TableCell>
          <TableCell>{mainItem.iop_total}</TableCell>
          <TableCell>{mainItem.taxvalue}</TableCell>
          <TableCell>{mainItem.iop_total}</TableCell>
        </TableRow>

        {!showSummary && mainItem.subcat && mainItem.subcat.length > 0 &&
          mainItem.subcat.map((subItem, subIndex) => (
            <TableRow key={`${mainIndex}-sub-${subIndex}`}>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>{subItem.description}</TableCell>
              <TableCell>{subItem.total}</TableCell>
              <TableCell>{subItem.taxval}</TableCell>
              <TableCell>{subItem.total}</TableCell>
            </TableRow>
        ))}
      </React.Fragment>
    );
  })}


  {salesbookData.length!== 0 && (
 <TableRow rowsSpan={4} >
 <TableCell></TableCell>
 <TableCell></TableCell>
 <TableCell></TableCell>
 <TableCell></TableCell>
 <TableCell></TableCell>
 <TableCell><b>Total</b></TableCell>
 <TableCell><b>{GrandNetTotal.toFixed(2)}</b></TableCell>
 <TableCell><b>{GrandTaxTotal.toFixed(2)}</b></TableCell>
 <TableCell><b>{GrandNetTotal.toFixed(2)}</b></TableCell>
	 

  </TableRow>)}
 
  {salesbookData.length === 0 && (
    <TableRow key="no-records">
      <TableCell align="center" colSpan={10}>No Records</TableCell>
    </TableRow>
  )}
</TableBody>


              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[50, 100, 150, 200]}
              component="div"
              count={this.state.totaldata}
              rowsPerPage={this.state.rowsPerPage}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
            />
          </Paper>
        </div>
		
		
		
		
		
      <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Generated Detailed Sales Day Book report</DialogTitle>
					
                    <DialogContent>
					<p> To generate a new report, based on the latest selection criteria you've specified, choose the format 
					you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
                        
			
	
		<ReactHTMLTableToExcel
                  variant="contained"
                  color="primary"
                  id="test-table-xls-button"
                  className="my-custom-excel-button"
                  table="salesbook"
                  filename="Sales Day Book Report"
                  sheet="Sales Day Book Report"
                  buttonText=""
                />
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.handleDownload} 
							style={{marginLeft:'50px'}}
                        >
                            Export to PDF
                        </Button>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>

      </React.Fragment>
    );
  }
}

   export class fromtodate extends Component {
  constructor(props) {
    super(props);
    this.state = {
		   fromdate: props.fromdate || new Date(),
      todate: props.todate || new Date(),
      fromdate1: props.fromdate1 || '',
      todate1: props.todate1 || '',
    };
  }

onchangedateHandler = (event) => {
  let selectedOption = event.target.value;
  const periodMap = {
    'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
   'This Quarter': [dayjs().startOf('month'), dayjs().endOf('month').add(3, 'month')],
    'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
    'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    'Last Quarter': [dayjs().endOf('month'), dayjs().startOf('month').subtract(3, 'month')],
    'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
	 'This Financial Year': [dayjs().startOf('Year').add(3, 'month'), dayjs().endOf('Year').add(3, 'month')],
	 'Last Financial Year': [dayjs().subtract(1, 'year').subtract(8, 'month'), dayjs().startOf('Year').add(2, 'month')],
    'Custom':[dayjs(), dayjs().endOf('month')]
  };

if (selectedOption === 'Custom') {
    this.setState({
      fromdate: periodMap['Custom'][0],
      todate: periodMap['Custom'][1],
      fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
      todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
      fromDateEnabled: true,
      toDateEnabled: true
    });
  } else {
    this.setState({
      fromdate: periodMap[selectedOption][0],
      todate: periodMap[selectedOption][1],
      fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
      todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
      fromDateEnabled: false,
      toDateEnabled: false
    });
  }
};


  
  
  todatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
	
 this.setState({
    todate: dayjs(dateObj),
    todate1: dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate(),
    toDateEnabled: true
  });
 

  }
  


  render() {
 return (
	
	 <React.Fragment>
	 <div className="searchbox">

<ul>

<li>
<p>Period</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.onchangedateHandler}
  inputProps={{tabIndex: "4"}}
        > <option>This Month</option>
          <option>This Quarter</option>
          <option>This Year</option>
          <option>Last Month</option>
          <option>Last Quarter</option>
          <option>Last Year</option>
          <option>This Financial Year</option>
          <option>Last Financial Year</option>
          <option>Custom</option>
  </Select></p>


</li>

	
<li>

<p><p>From Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.fromDateEnabled}
      value={dayjs(this.state.fromdate)}
      className="txtbox"
      onChange={this.fromdatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p>

</li>


<li>


<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.toDateEnabled}
      value={dayjs(this.state.todate)}
      className="txtbox"
      onChange={this.todatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p></li>
	
	
	</ul>
	</div>
	 </React.Fragment>

  )}
   }